import {Layout as ADLayout} from "antd";
import {Outlet, useLocation} from "react-router-dom";
import styled from "styled-components";
import {Navbar} from "./components";
import {items, bottomMenuItems} from "../assets";
import {useEffect, useState} from "react";

const {Content, Footer} = ADLayout;

const AntDesignLayout = styled(ADLayout)`
  background-color: #FCFCFD;
  @media screen and (max-width: 420px) {
    .ant-layout-header {
      height: auto;
    }
  }
`;
const UserLayout = () => {
    const location = useLocation()
    const [showNavBar, setShowNavBar] = useState<boolean>(true)
    useEffect(() => {
        if (location.pathname === "/location" ||
            location.pathname === "/admin-panel" ||
            location.pathname === "/ad-insert-step-one" ||
            location.pathname === "/ad-insert-step-two" ||
            location.pathname === "/ad-edit-step-one/:id" ||
            location.pathname.startsWith("/ad-edit-step-two")  ||
            location.pathname.startsWith("/product-detail")  ||
            location.pathname === "/terms" ||
            location.pathname === "/conditions" ||
            location.pathname.startsWith("/ad-edit-step-three")||
            location.pathname === "/ad-insert-step-three" ||
            location.pathname.startsWith("/ad-edit-step-one")
        ) {
            setShowNavBar(false)
        } else {
            setShowNavBar(true)
        }
    }, [location.pathname]);
    return (
        <AntDesignLayout>
            <Content
                style={{
                    padding: 24,
                    minHeight: 280,
                }}
            >
                <Outlet/>
            </Content>
            {showNavBar && <Navbar menuItems={items} bottomMenuItems={bottomMenuItems}/>}
        </AntDesignLayout>
    );
};

export default UserLayout;
